// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2uuBm","right":"styles_right__11Aoi"};